import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { map, Observable } from 'rxjs';
import { LeadHead } from 'src/app/core/models/lead/lead-head.model';
import { Lead } from 'src/app/core/models/lead/lead.model';
import { SearchSuggestion } from '../../inputs/autocomplete/search-strategy-base';
import { AutocompleteUserSuggestionService } from 'src/app/shared/common-features/services/autocomplete-strategies/autocomplete-user-suggestion.service';
import { UserImageProviderService } from 'src/app/shared/common-features/services/option-image-providers/user-image-provider.service';

export interface AssignationRequest {
  leadId: number
  userId: number
  deadLine: Date
}

@Component({
    selector: 'app-assign-lead-dialog',
    templateUrl: './assign-lead-dialog.component.html',
    styleUrls: ['./assign-lead-dialog.component.scss'],
    standalone: false
})
export class AssignLeadDialogComponent implements OnInit {

  userFormControl = new FormControl<string>('')

  lead: Lead

  private selectedUserId: number | undefined
  private defaultDeadline: Date

  constructor(private dialogRef: MatDialogRef<AssignLeadDialogComponent, AssignationRequest | null>,
    @Inject(MAT_DIALOG_DATA) lead: Lead,
    readonly autocompleteUserSuggestionService: AutocompleteUserSuggestionService,
    readonly userImageProviderService: UserImageProviderService) {
    this.lead = lead

    this.defaultDeadline = new Date()
    this.defaultDeadline.setHours(this.defaultDeadline.getHours() + 24)
  }

  ngOnInit(): void {
  }

  onSelectedUserSuggestion(suggestion: SearchSuggestion | null) {
    this.selectedUserId = suggestion?.id ? Number(suggestion?.id) : undefined
  }

  onConfirmClick() {
    if (this.selectedUserId && this.userFormControl.value != '')
      this.dialogRef.close({
        leadId: this.lead.id,
        userId: this.selectedUserId,
        deadLine: this.defaultDeadline
      })
  }

  onCancelClick() {
    this.dialogRef.close(null)
  }

  static createConfigurations(lead: LeadHead): MatDialogConfig {
    return {
      height: '260px',
      data: lead,
      autoFocus: false,
      disableClose: true
    }
  }

}
